"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _reactSpring = require("react-spring");

var _noop = _interopRequireDefault(require("lodash/noop"));

var _classnames = _interopRequireDefault(require("classnames"));

var _QuickAction = require("../QuickAction");

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _Check = _interopRequireDefault(require("@material-ui/icons/Check"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _Button = _interopRequireWildcard(require("../Button"));

var _FrostedBackdrop = _interopRequireDefault(require("../FrostedBackdrop"));

var CustomBackdrop = function CustomBackdrop(props) {
  return /*#__PURE__*/_react["default"].createElement(_FrostedBackdrop["default"], (0, _extends2["default"])({}, props, {
    blur: 32,
    background: "transparent"
  }));
};

var Layout = function Layout(_ref) {
  var icon = _ref.icon,
      children = _ref.children,
      onClick = _ref.onClick,
      className = _ref.className,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["icon", "children", "onClick", "className"]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, props, {
    className: (0, _classnames["default"])('flex items-center rounded-xl select-none', className),
    onClick: onClick
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mr-8"
  }, icon), children);
};

var PopupItem = function PopupItem(_ref2) {
  var trigger = _ref2.trigger,
      _ref2$delay = _ref2.delay,
      delay = _ref2$delay === void 0 ? 0 : _ref2$delay,
      name = _ref2.name,
      description = _ref2.description,
      checked = _ref2.checked,
      onExited = _ref2.onExited,
      props = (0, _objectWithoutProperties2["default"])(_ref2, ["trigger", "delay", "name", "description", "checked", "onExited"]);
  var style = (0, _reactSpring.useSpring)({
    from: {
      opacity: 0,
      marginTop: -60
    },
    to: {
      opacity: 1,
      marginTop: 0
    },
    reverse: !trigger,
    config: {
      duration: 200
    },
    onRest: !trigger ? function () {
      return !!onExited && onExited();
    } : null
  });
  return /*#__PURE__*/_react["default"].createElement(_reactSpring.animated.div, {
    style: style
  }, /*#__PURE__*/_react["default"].createElement(Layout, (0, _extends2["default"])({}, props, {
    style: {
      paddingLeft: 40,
      paddingRight: 40,
      marginLeft: -40
    },
    className: (0, _classnames["default"])('py-6 my-2 box-border border border-transparent hover:bg-secondary', {
      'border-primary bg-secondary': checked,
      'cursor-pointer hover:border-gray-light': !checked
    })
  }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-bold"
  }, name), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-light"
  }, description))));
};

var Popup = function Popup(_ref3) {
  var selected = _ref3.selected,
      avatar = _ref3.avatar,
      isOpen = _ref3.isOpen,
      position = _ref3.position,
      onClose = _ref3.onClose,
      onChange = _ref3.onChange;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      animateIn = _useState2[0],
      setAnimateIn = _useState2[1];

  var _useState3 = (0, _react.useState)(selected),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      action = _useState4[0],
      setAction = _useState4[1];

  var handleOnSubmit = function handleOnSubmit() {
    onChange(action);
    setAnimateIn(false);
  };

  (0, _react.useLayoutEffect)(function () {
    setAnimateIn(true);
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    fullScreen: true,
    disableBackdropClick: true,
    open: isOpen,
    onClose: onClose,
    BackdropComponent: CustomBackdrop,
    PaperProps: {
      style: {
        backgroundColor: 'transparent'
      }
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute flex flex-col",
    style: {
      top: position.y,
      left: position.x
    }
  }, /*#__PURE__*/_react["default"].createElement(Layout, {
    icon: avatar,
    className: "mb-6"
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-bold text-xl"
  }, t('threadList.quickAction.title')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-semibold text-light"
  }, t('threadList.quickAction.description')))), /*#__PURE__*/_react["default"].createElement(PopupItem, {
    trigger: animateIn,
    icon: /*#__PURE__*/_react["default"].createElement(_QuickAction.Done, {
      noTooltip: true,
      onClick: _noop["default"]
    }),
    checked: action === _QuickAction.quickActions.archive,
    name: t('thread.actions.archive'),
    description: t('settings.general.quickAction.done.description'),
    onClick: function onClick() {
      return setAction(_QuickAction.quickActions.archive);
    }
  }), /*#__PURE__*/_react["default"].createElement(PopupItem, {
    trigger: animateIn,
    onExited: onClose,
    icon: /*#__PURE__*/_react["default"].createElement(_QuickAction.Trash, {
      noTooltip: true,
      onClick: _noop["default"]
    }),
    checked: action === _QuickAction.quickActions.trash,
    name: t('thread.actions.trash'),
    description: t('settings.general.quickAction.trash.description'),
    onClick: function onClick() {
      return setAction(_QuickAction.quickActions.trash);
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute",
    style: {
      top: position.y + 400,
      left: position.x
    }
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    disabled: !action,
    className: "w-56",
    onClick: handleOnSubmit
  }, animateIn ? t('button.save') : /*#__PURE__*/_react["default"].createElement(_Check["default"], {
    fontSize: "small"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute right-0 top-0 mt-8 mr-8"
  }, /*#__PURE__*/_react["default"].createElement(_Button.FabButton, {
    title: "Close",
    onClick: function onClick(e) {
      e.stopPropagation();
      onClose();
    }
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null))));
};

var _default = Popup;
exports["default"] = _default;
//# sourceMappingURL=index.js.map